import * as React from 'react';
export var IcMenu = function () {
    return (React.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', display: 'block' },
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3 8.5V6.5H21V8.5H3ZM3 13.5H21V11.5H3V13.5ZM3 18.5H21V16.5H3V18.5Z', fill: '#01322B' })));
};
